import { Undefinable } from "@becon-team/becon-fe-lib/my-types";

const queryKeys = {
  // FOREHEAD
  GET_FOREHEAD_V3_HISTORIES: "GET_FOREHEAD_V3_HISTORIES",
  GET_FOREHEAD_V3_RESULT: "GET_FOREHEAD_V3_RESULT",
  GET_FOREHEAD_V2_RESULT: "GET_FOREHEAD_V2_RESULT",
  GET_FOREHEAD_V2_HISTORIES: "GET_FOREHEAD_V2_HISTORIES",
  GET_FOREHEAD_V2_RANK: "GET_FOREHEAD_V2_RANK",
  // SCALP
  GET_SCALP_RESULT: "GET_SCALP_RESULT",
  GET_SCALP_HISTORY: "GET_SCALP_HISTORY",
  GET_GLOBAL_POLICY: "GET_GLOBAL_POLICY",
  GET_SCALP_RANK: "GET_SCALP_RANK",
  GET_SCALP_ANALYSIS_AVERAGE: "GET_SCALP_ANALYSIS_AVERAGE",
  // COMMUNITY
  GET_POST_LIST: "GET_POST_LIST",
  GET_TOP_POST_LIST: "GET_TOP_POST_LIST",
  GET_POST: "GET_POST",
  GET_POST_COMMENTS: "GET_POST_COMMENTS",
  GET_COMMUNITY_CATEGORY: "GET_COMMUNITY_CATEGORY",
  // BLOG
  GET_USER_CUSTOM_BLOG_INFOS: "GET_USER_CUSTOM_BLOG_INFOS",
  GET_DETAIL_BLOG_INFOS: "GET_DETAIL_BLOG_INFOS",
  GET_TODAY_BLOG_INFOS: "GET_TODAY_BLOG_INFOS",
  // AUTH
  GET_REQUEST_FORGOTTEN_EMAIL: "GET_REQUEST_FORGOTTEN_EMAIL",
  GET_MY_ACCOUNT_INFO: "GET_MY_ACCOUNT_INFO",
  // SHAMPOO
  GET_TOP_RANKED_SHAMPOO_LIST: "GET_TOP_RANKED_SHAMPOO_LIST",
  GET_SHAMPOO_LIST: "GET_SHAMPOO_LIST",
  GET_SHAMPOO_INGREDIENT_INFO_LIST: "GET_SHAMPOO_INGREDIENT_INFO_LIST",
  GET_SHAMPOO_INFO: "GET_SHAMPOO_INFO",
  // GET_ANALYSIS_HISTORY_B2B
  GET_ANALYSIS_HISTORY_B2B: "GET_ANALYSIS_HISTORY_B2B",
  // WEATHER
  GET_WEATHER: "GET_WEATHER",
  // MYPAGE
  GET_MY_PROFILE: "GET_MY_PROFILE",
  GET_MY_COMMENT: "GET_MY_COMMENT",
  GET_MY_LIKED_BLOG: "GET_MY_LIKED_BLOG",
  GET_MY_LIKED_POST: "GET_MY_LIKED_POST",
  GET_MY_POST: "GET_MY_POST",
  GET_POINT_HISTORY_INFO: "GET_POINT_HISTORY_INFO",
  // CHALLENGE
  GET_CHALLENGE_LIST: "GET_CHALLENGE_LIST",
  // PARTNERSHIP_LIST
  GET_PARTNERSHIP_LIST: "GET_PARTNERSHIP_LIST",
  // INQUIRY
  GET_INQUIRY: "GET_INQUIRY",
  share: {
    b2bAnalysis: {
      list: (userId: Undefinable<string>) => ["share", "b2b", "analysis", userId, "list"],
    },
  },
  skin: {
    stat: (userId: Undefinable<string>) => ["skin", userId, "stat"],
    list: (userId: Undefinable<string>) => ["skin", userId, "list"],
    skinAnalysisSetId: (userId: Undefinable<string>, skinAnalysisSetId: Undefinable<number>) => [
      "skin",
      userId,
      skinAnalysisSetId,
    ],
    inquiry: (userId: Undefinable<string>) => ["skin", userId, "inquiry"],
    trend: (userId: Undefinable<string>) => ["skin", userId, "trend"],
    averageScore: (userId: Undefinable<string>) => ["skin", userId, "averageScore"],
    skinMicroB2B: {
      skinAnalysisSetId: (userId: Undefinable<string>, skinAnalysisSetId: Undefinable<number>) => [
        "skin",
        userId,
        "analysis",
        skinAnalysisSetId,
      ],
    },
  },
  scalp: {
    trend: (userId: Undefinable<string>) => ["scalp", userId, "trend"],
    stat: (userId: Undefinable<string>) => ["scalp", userId, "stat"],
    list: (userId: Undefinable<string>) => ["scalp", userId, "list"],
    result: (userId: Undefinable<string>) => ["scalp", userId, "list"],
    forehead: {
      list: (userId: Undefinable<string>) => ["scalp", userId, "forehead", "list"],
      result: (userId: Undefinable<string>, setId: Undefinable<number>) => ["scalp", userId, "forehead", setId],
    },
    smp: {
      compositeSetId: (userId: Undefinable<string>, compositeSetId: Undefinable<number>) => [
        "scalp",
        userId,
        "smp",
        compositeSetId,
      ],
    },
    comparisonSet: {
      comparisonSetResult: (userId: Undefinable<string>, comparisonSetId: Undefinable<number>) => [
        "scalp",
        userId,
        "comparisonSetResult",
        comparisonSetId,
      ],
    },
    compositeScalp: {
      compositeId: (userId: Undefinable<string>, compositeId: Undefinable<number>) => [
        "scalp",
        userId,
        "compositeScalp",
        compositeId,
      ],
    },
    crown: {
      list: (userId: Undefinable<string>) => ["scalp", userId, "crown", "list"],
      result: (userId: Undefinable<string>, setId: Undefinable<number>) => ["scalp", userId, "crown", setId],
      compositeSetId: (userId: Undefinable<string>, compositeSetId: Undefinable<number>) => [
        "scalp",
        userId,
        "crown",
        compositeSetId,
      ],
    },
  },
  user: {
    list: ["user", "list"],
    userId: (userId: Undefinable<string>) => ["user", userId],
    inquiry: (userId: Undefinable<string>) => ["user", "inquiry", userId],
    healthInquiry: (userId: Undefinable<string>) => ["user", "healthInquiry", userId],
  },
  account: {
    my: ["account", "my"],
    users: ["account", "users"],
  },
  partner: {
    list: ["partner", "list"],
  },
} as const;

export default queryKeys;
